import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProgramGanttViewComponent } from './program-gantt-view.component';

const routes: Routes = [
  {
    path: '',
    component: ProgramGanttViewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProgramGanttViewRoutingModule { }
